var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { COLORS } from 'src/shared/styles/colors';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import styles from './SelectSection.module.scss';
import { IDENTIFIER_SELECT_OPTION_ITEM, IDENTIFIER_SELECT_SECTION } from 'src/ui/components/Input/SelectSection/constants';
export var E_SELECT_SECTION_THEME;
(function (E_SELECT_SECTION_THEME) {
    E_SELECT_SECTION_THEME[E_SELECT_SECTION_THEME["NEUTRAL"] = 0] = "NEUTRAL";
    E_SELECT_SECTION_THEME[E_SELECT_SECTION_THEME["RED"] = 1] = "RED";
    E_SELECT_SECTION_THEME[E_SELECT_SECTION_THEME["GREEN"] = 2] = "GREEN";
})(E_SELECT_SECTION_THEME || (E_SELECT_SECTION_THEME = {}));
export var SelectSection = function (props) {
    var _a;
    var list = props.list, currentFocus = props.currentFocus, currentValue = props.currentValue, currentValueLabel = props.currentValueLabel, className = props.className, _b = props.theme, theme = _b === void 0 ? E_SELECT_SECTION_THEME.NEUTRAL : _b, onSelectCurrentItem = props.onSelectCurrentItem;
    var initialsDuplicates = list.map(function (item) { return item.trim().substring(0, 1); });
    var sectionInitials = initialsDuplicates
        .filter(function (value, index) { return initialsDuplicates.indexOf(value) === index; })
        .sort(function (a, b) { return (a > b ? 1 : -1); });
    var sectionLineClassNames = classNames(styles.lineDisplay, styles.sectionInitial);
    var selectSectionClassName = classNames(styles.selectSectionWrapper, (_a = {},
        _a[styles.neutralSelectSection] = theme === E_SELECT_SECTION_THEME.NEUTRAL,
        _a[styles.greenSelectSection] = theme === E_SELECT_SECTION_THEME.GREEN,
        _a[styles.redSelectSection] = theme === E_SELECT_SECTION_THEME.RED,
        _a), className);
    return (_jsx("div", __assign({ "data-test": IDENTIFIER_SELECT_SECTION, className: selectSectionClassName }, { children: sectionInitials.map(function (initial) {
            var listBySection = list.filter(function (item) { return initial === item.trim()[0]; });
            return (_jsxs("ul", { children: [_jsx("li", __assign({ className: sectionLineClassNames }, { children: initial })), _jsx("ul", { children: listBySection.map(function (item, indexSection) {
                            var _a, _b;
                            var isCurrentItem = currentValue ? currentValue.toLowerCase() === item.toLowerCase() : false;
                            var isCurrentItemSelected = currentFocus === item;
                            var currentItemClassNames = classNames(styles.lineDisplay, (_a = {},
                                _a[styles.currentValue] = isCurrentItem,
                                _a[styles.labelItem] = !isCurrentItem,
                                _a[styles.active] = isCurrentItemSelected,
                                _a));
                            var checkIconClassNames = classNames(styles.checkIcon, (_b = {},
                                _b[styles.checkIconActive] = isCurrentItemSelected,
                                _b));
                            return (_jsxs("li", __assign({ "data-test": IDENTIFIER_SELECT_OPTION_ITEM, className: currentItemClassNames, onClick: isCurrentItem ? null : function () { return onSelectCurrentItem(item); } }, { children: [_jsx("span", { children: item }), isCurrentItem ? (currentValueLabel && _jsx("span", __assign({ className: styles.currentItemSubtitle }, { children: currentValueLabel }))) : (_jsx(Icons, { icon: E_ICONS.CHECK, color: COLORS.GRAY['50'], className: checkIconClassNames }))] }), "".concat(item, "-").concat(indexSection)));
                        }) })] }, initial));
        }) })));
};
